import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { POW_FEATURES } from "../../services/powFeatures.service";
import { PowFeature } from "../PowFeature";
import { Button } from "@material-ui/core";
import { OperationalConfigurationOverridesList } from "./OperationalConfigurationOverridesList";
import { OperationalConfigurationOverrideEdit } from "./OperationalConfigurationOverrideEdit";
import { OperationalConfigurationOverride } from "../../models/OperationalConfiguration";

interface OperationalConfigurationOverridesProps {
	// overrides list
	operationalConfigurationOverrides: OperationalConfigurationOverride[];
	// product id
	productId: string;
	// id of parent operational config
	operationalConfigurationId: string;
	// function to call on successful save
	onSuccess: () => void;
}

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: theme.spacing(4),
	},
	titleWrapper: {
		maxWidth: theme.breakpoints.values.md,
		display: "flex",
		justifyContent: "space-between",
	},
}));

const configOverrideFormModes = {
	DISPLAY: "DISPLAY",
	ADD: "ADD",
	EDIT: "EDIT",
};

/**
 * Display operational configuration overrides
 * @param props
 */
export const OperationalConfigurationOverrides = (props: OperationalConfigurationOverridesProps) => {
	const classes = useStyles();

	const [configOverrideFormMode, setConfigOverrideFormMode] = React.useState<{
		mode: string;
		operationalConfigOverride: OperationalConfigurationOverride | null;
	}>({
		mode: configOverrideFormModes.DISPLAY,
		operationalConfigOverride: null,
	});

	const cancel = () =>
		setConfigOverrideFormMode({
			mode: configOverrideFormModes.DISPLAY,
			operationalConfigOverride: null,
		});

	const edit = (operationalConfigurationOverride: OperationalConfigurationOverride) =>
		setConfigOverrideFormMode({
			mode: configOverrideFormModes.EDIT,
			operationalConfigOverride: operationalConfigurationOverride,
		});

	return (
		<div>
			<div className={classes.titleWrapper}>
				<Typography className={classes.title} variant="h5">
					Operational Configuration Overrides
				</Typography>
				<div>
					{configOverrideFormMode.mode === configOverrideFormModes.DISPLAY && (
						<PowFeature feature={POW_FEATURES.paConfigurations_Admin}>
							<div data-testid="operational-configuration-overrides-add-button">
								<Button
									size="small"
									variant="outlined"
									color="primary"
									onClick={() =>
										setConfigOverrideFormMode({
											mode: configOverrideFormModes.ADD,
											operationalConfigOverride: null,
										})
									}
								>
									Add new override
								</Button>
							</div>
						</PowFeature>
					)}
				</div>
			</div>
			{configOverrideFormMode.mode === configOverrideFormModes.DISPLAY && (
				<OperationalConfigurationOverridesList
					productId={props.productId}
					operationalConfigurationOverrides={props.operationalConfigurationOverrides}
					onSuccess={props.onSuccess}
					handleEdit={edit}
				/>
			)}
			{configOverrideFormMode.mode === configOverrideFormModes.ADD && (
				<OperationalConfigurationOverrideEdit
					productId={props.productId}
					operationalConfigurationOverride={null}
					operationalConfigurationId={props.operationalConfigurationId}
					onSuccess={props.onSuccess}
					onCancel={cancel}
				/>
			)}
			{configOverrideFormMode.mode === configOverrideFormModes.EDIT && (
				<OperationalConfigurationOverrideEdit
					productId={props.productId}
					operationalConfigurationOverride={configOverrideFormMode.operationalConfigOverride}
					operationalConfigurationId={props.operationalConfigurationId}
					onSuccess={props.onSuccess}
					onCancel={cancel}
				/>
			)}
		</div>
	);
};
